module.exports = __webpack_public_path__ + "static/naofumi0628-42154efe7cdb257446a725921d5d991c.jpg";